import { map } from 'rxjs/operators/map';
import { StatusSummarySerializer } from '../../models';
import ajax from '../../utils/ajax';

class StatusSummaryService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/status';

  getAll = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(
      map(data => {
        let serializedResponse =
          data &&
          data.response.map(dataResponse => {
            dataResponse = StatusSummarySerializer.normalize(dataResponse);
            return dataResponse;
          });
        serializedResponse.sort((a, b) => a.statusPriority - b.statusPriority);
        return serializedResponse;
      })
    );
  };
}
export default new StatusSummaryService();



// WEBPACK FOOTER //
// ./src/services/status/index.js